import React, { useEffect, useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { AddOneBetGame, RemoveOneBet } from '../../common/actions/betAction';
import { convertBetMarket, convertBetMarketName, isEmpty, toastr } from '../../common/cores';


const MarketItem = (props) => {
    const market = props.market;

    const { bettedItems, sports, key, betgametype } = props;
    // console.log(convertBetMarketName(market.name))
    // console.log(props);
    const checkBetted = (item, index, number) => {
        if (betgametype === "bet365") {

            return bettedItems.findIndex(list => list.betId === (sports.activeId + "_" + item.cate1 + "_" + index + "_" + number)) >= 0;
        } else {
            return bettedItems.findIndex(list => list.betId === (`${sports.activeId.split("_")[0]}_${sports.activeId.split("_")[2]}_${sports.activeId.split("_")[1]}` + "_" + item.cate1 + "_" + index + "_" + number)) >= 0;
        }
    }

    const onBet = (item, index, number) => {
        let gameDate = new Date(props.date.date);
        let dateNow = new Date()


        // if(gameDate < dateNow) {
        //     return toastr.warning("배팅시간이 지났습니다.");
        // }

        if (checkBetted(item, index, number)) {
            if (betgametype === "bet365") {

                props.RemoveOneBet(sports.activeId + "_" + item.cate1 + "_" + index + "_" + number);
                return;
            } else {
                props.RemoveOneBet((`${sports.activeId.split("_")[0]}_${sports.activeId.split("_")[2]}_${sports.activeId.split("_")[1]}` + "_" + item.cate1 + "_" + index + "_" + number));
                return;
            }
        }
        let isbet = props.AddOneBetGame({
            ...item,
            index,
            number,
            betId: betgametype === "bet365" ? sports.activeId + "_" + item.cate1 + "_" + index + "_" + number : `${sports.activeId.split("_")[0]}_${sports.activeId.split("_")[2]}_${sports.activeId.split("_")[1]}` + "_" + item.cate1 + "_" + index + "_" + number,
            marketId: sports.activeId + "_" + item.cate1 + "_" + index,
            eventKey: sports.activeId,
            date: props.date.date,
            type: betgametype
        })
        if (!isbet) toastr.warning('배팅규정에 어긋납니다.');
    }
    return market.markets.length > 0 && (
        <div className="sport_more_list_wrap" key={key}>
            <div className="sport_more_title">
                {convertBetMarketName(market.name)}
            </div>
            {
                market.markets.map((item, index) => {
                    return (
                        <div className="sport_more_list" key={index}>
                            <ul>
                                <li className={`more_team1 col ${checkBetted(item, index, 0) && "active"}`} onClick={() => onBet(item, index, 0)}>
                                    <span className="team_l">{item.home}</span>
                                    <span className="team_r font07">&nbsp;{item.ratio1}</span>
                                </li>
                                {((item.cate1 !== "underover" && item.cate1 !== "handicap") && item.ratio2 != 0) &&
                                    <li className={`more_team1 col ${checkBetted(item, index, 1) && "active"}`} onClick={() => onBet(item, index, 1)}>
                                        <span className="team_l">무승부</span>
                                        <span className="team_r">{item.ratio2}</span>
                                    </li>}
                                <li className={`more_team2 col ${checkBetted(item, index, 2) && "active"}`} onClick={() => onBet(item, index, 2)}>
                                    <span className="team_l">{item.ratio3}</span>
                                    <span className="team_r">{item.away}</span>
                                </li>
                            </ul>
                        </div>
                    )
                })
            }
        </div>
    )

};

const mapStateToProps = state => ({
    sports: state.sports,
    bettedItems: state.bet.bettedItems,
})

export default connect(mapStateToProps, {
    AddOneBetGame,
    RemoveOneBet
})(MarketItem);


// WEBPACK FOOTER //
// ./src/components/BetGame/MarketItem.js